import { Component, Inject, Input, Optional } from '@angular/core';
import { environment } from '~env/environment';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { ZRPElementsClickApplicationEvent } from '~shared/modules/application-event/models/ZRP-elements-click-application-event.model';
import { APP_CATEGORY_ROUTE } from '~shared/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-out-of-scope-category-grid',
  templateUrl: './out-of-scope-category-grid.component.html',
  styleUrls: ['./out-of-scope-category-grid.component.scss'],
})
export class OutOfScopeCategoryGridComponent {
  constructor(
    private router: Router,
    private applicationEventService: ApplicationEventService,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any
  ) {}

  @Input() isMobile: boolean;
  @Input() cards: any;
  readonly NOT_EXPANDED_LIMIT = 4;
  readonly marketplaceLink = environment.appBaseUrl();
  isExpanded = false;
  country = getCountryDomainCode(this.webAppBuyerRequest);

  get limit(): number {
    return this.isExpanded || !this.isMobile ? this.cards.length : this.NOT_EXPANDED_LIMIT;
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  goTo(card): void {
    this.gAEventForCategoryGridClick(card.name);
    this.router.navigate([`/${APP_CATEGORY_ROUTE}/${card.slug}`]);
  }

  gAEventForCategoryGridClick(categoryName: string): void {
    this.applicationEventService.publish(
      new ZRPElementsClickApplicationEvent(GATrackingEventType.ZRPOutOfScopeCategoryGrid, categoryName)
    );
  }
}
